export default "/assets/images/rookie-parent4.png?9feca135367d447d8dccbc73c50c2542";